import { render, staticRenderFns } from "./SendingDenied.vue?vue&type=template&id=fef93cc0&"
import script from "./SendingDenied.vue?vue&type=script&lang=js&"
export * from "./SendingDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports